import api from './api';
import {
  BarberProfileDto,
  UpdateBarberProfileDto,
  BarberServiceOfferingDto,
  CreateBarberServiceOfferingDto,
  UpdateBarberServiceOfferingDto,
  BarberLocationsResponse
} from '../types/barberProfile';

export const barberProfileApi = {
  // Profile endpoints
  getProfile: async (barberId: number): Promise<BarberProfileDto> => {
    const response = await api.get(`/barberprofile/${barberId}`);
    return response.data;
  },

  getMyProfile: async (): Promise<BarberProfileDto> => {
    const response = await api.get('/barberprofile/me');
    return response.data;
  },

  getMyLocations: async (): Promise<BarberLocationsResponse> => {
    const response = await api.get('/barberprofile/my-locations');
    return response.data;
  },

  updateProfile: async (barberId: number, data: UpdateBarberProfileDto): Promise<void> => {
    await api.put(`/barberprofile/${barberId}`, data);
  },

  // Service offerings endpoints
  getServices: async (barberId: number): Promise<BarberServiceOfferingDto[]> => {
    const response = await api.get(`/barberprofile/${barberId}/services`);
    return response.data;
  },

  addService: async (barberId: number, data: CreateBarberServiceOfferingDto): Promise<BarberServiceOfferingDto> => {
    const response = await api.post(`/barberprofile/${barberId}/services`, data);
    return response.data;
  },

  updateService: async (barberId: number, serviceId: number, data: UpdateBarberServiceOfferingDto): Promise<void> => {
    await api.put(`/barberprofile/${barberId}/services/${serviceId}`, data);
  },

  deleteService: async (barberId: number, serviceId: number): Promise<void> => {
    await api.delete(`/barberprofile/${barberId}/services/${serviceId}`);
  }
};

export default barberProfileApi;
